import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import bg1 from "../../assets/images/bg/donation.jpg";
import Scanner from "../../assets/images/qr/qrcode.jpeg";
import chndravanalogo from "../../assets/images/home/rangabandilogo.png";

const Donations = () => {
  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{ backgroundImage: `url(${bg1})` }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-8 d-flex flex-column">
              <div className="card login-page shadow rounded border-0 flex-grow-1">
                <div className="card-body d-flex flex-column">
                  <h4 className="text-center">
                    Empower Theater, Inspire Generations: Support Rangabandi
                    Today!
                  </h4>
                  <hr />
                  <div className="row justify-content-center flex-grow-1">
                    <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center">
                      <img
                        src={chndravanalogo}
                        alt="qr code"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center">
                      <p style={{ fontSize: "15px", fontWeight: "bold" }}>
                        Support the Art of Theater with Rangabandi
                      </p>
                      <p className="para-desc text-muted">
                        Rangabandi thrives on your support to inspire
                        communities through workshops, impactful plays, and
                        mythological productions. Your contribution helps us
                        reach wider audiences, nurture talent, and keep the
                        spirit of theater alive.
                      </p>
                      <p className="para-desc text-muted">
                        Be a Catalyst for Cultural Growth Your sponsorship
                        supports Rangabandi in creating thought-provoking
                        performances and empowering individuals through theater.
                        Join us in preserving this timeless art and fostering
                        cultural growth for future generations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 d-flex flex-column">
              <div className="card login-page shadow rounded border-0 flex-grow-1">
                <div className="card-body">
                  <h4 className="text-center">Account details</h4>
                  <hr />
                  <div className="row justify-content-center flex-grow-1">
                    <div>
                      <img src={Scanner} alt="qr code" className="img-fluid" />
                    </div>
                    <div className="row justify-content-center mt-3">
                      <h6 className="para-desc text-muted">
                        Bank Name : State Bank of India
                      </h6>
                      <h6 className="para-desc text-muted">
                        Account Name : Rangabandi Malavalli
                      </h6>
                      <h6 className="para-desc text-muted">
                        Account No : 00000041722608333
                      </h6>
                      <h6 className="para-desc text-muted">
                        IFSC Code : SBIN0040036
                      </h6>
                      <h6 className="para-desc text-muted">
                        Branch : Malavalli
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Donations;
